export default __webpack_public_path__ + "static/media/testBanner.cde8d92d.jpg";